import { provideApolloClient } from "@vue/apollo-composable";
import {gqlGetPortfolio, gqlGetPortfolios} from "@/graphql/portfolios";
import { effectScope } from "vue";
import { apolloClient } from "@/utils/apolloClient";

export const hasSippNoSecurityAllocationsAndTargetRetirementAge = async ({ params }) => {
    const scope = effectScope(true);

    try {
        return await scope.run(async () => {
            provideApolloClient(apolloClient);

            try {
                const response = await apolloClient.query({
                    query: gqlGetPortfolio,
                    variables: {
                        portfolioId: params?.portfolioId
                    },
                    fetchPolicy: 'no-cache',
                });

                const clientInfo = response
                    ?.data
                    ?.clientInfo

                if (clientInfo?.portfolio) {
                    const hasTargetRetirementAge = clientInfo?.targetRetirementAge

                    if (!hasTargetRetirementAge && params?.portfolioId) {
                        return `/pension/onboarding/${params.portfolioId}`
                    }
                }

                return true
            } catch (error) {
                console.error('Query error:', error);
                return false
            }
        });
    } finally {
        scope.stop();
    }
};